/** @format */

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import clientFilesReducer from './clientFilesSlice';
import leadReducer from './leadSlice';
import { listenerMiddleware } from './listenerMiddleware';
import pdfReducer from './pdfSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    pdf: pdfReducer,
    clientFiles: clientFilesReducer,
    lead: leadReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).prepend(
      listenerMiddleware.middleware,
    ),
});

export { store };

export default null;
